<template>
  <div id="app">
    <router-view></router-view>
    <!--<Login msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
import home from './home/home.vue'

export default {
  name: 'App',
  components: {
    home
  }
}
</script>

<style>
#app {
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0a0a0f;
  min-height: 100vh;
}
</style>
